import React from 'react';
import PaymentMethodBasicComponent from './payment-method-basic.component';
import PaymentMethodRazorPayConfigurationComponent from './payment-razorpay-method';
import PaymentMethodCCAvenueConfigurationComponent from './payment-CCAvenue-method.component';
import PaymentMethodPhonePeConfigurationComponent from './payment-PhonePe-method.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

export const PaymentMethodComponent = ({
  handleBasicInnerFormChange, chosenPaymentMethod, stores, 
  selectCCAVenues, handleCCAvenueFormChange, handleDeleteCCAvenueRow,
  handleInnerFormChange, selectRazorpay, back, handleFormSubmit
}: any) => {

  const tabItems = [
    {
      id: 0,
      title: 'Basic Configuration',
      component: <PaymentMethodBasicComponent
        handleBasicInnerFormChange={handleBasicInnerFormChange}
        chosenPaymentMethod={chosenPaymentMethod}
        stores={stores}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'RazorPay Configuration',
      component: <PaymentMethodRazorPayConfigurationComponent
        handleInnerFormChange={handleInnerFormChange}
        selectRazorpay={selectRazorpay}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'CCAvenue Configuration',
      component: <PaymentMethodCCAvenueConfigurationComponent
        handleCCAvenueFormChange={handleCCAvenueFormChange}
        selectCCAVenues={selectCCAVenues}
        handleDeleteCCAvenueRow={handleDeleteCCAvenueRow}
      />,
      isVisible: true,
    },
    {
      id: 3,
      title: 'PhonePe Configuration',
      component: <PaymentMethodPhonePeConfigurationComponent
        handleInnerFormChange={handleInnerFormChange}
        selectRazorpay={selectRazorpay}
      />,
      isVisible: true,
    }
  ];

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default PaymentMethodComponent;
